import { z } from "zod";

// Helpers
const optionalNumber = z.coerce.number().int().nullable().optional();
const optionalDecimal = z.coerce.number().nullable().optional(); // For decimal(18, 2)
const optionalString = z.coerce.string().trim().nullable().optional().transform(e => e === '' ? null : e);
const optionalBoolean = z.boolean().nullable().optional();
const optionalDate = z.coerce.date().nullable().optional();

export const MedicaoTerceirizacaoSchema = z.object({
  IdMedicaoTerceirizacao: z.number().int().default(0),
  NrMedicaoTerceirizacao: optionalNumber,
  IdContrato: z.number(),
  DataMedicao: optionalDate,
  DataDe: optionalDate,
  DataAte: optionalDate,
  IdFuncionarioResp: optionalNumber,
  Imposto: optionalDecimal,
  Acrescimo: optionalDecimal,
  Desconto: optionalDecimal,
  PercRetencao: optionalDecimal,
  InformacoesGerais: optionalString,
  Status: optionalNumber,
  PgtoProvisionado: optionalBoolean,
  NroNotaFiscal: optionalString.pipe(z.string().max(50, "Máximo de 50 caracteres").nullable().optional()),
  NotaFiscalEntregue: optionalNumber,
  FornecedorAvaliado: optionalBoolean,
  Entregue: optionalBoolean,
  NrNotaFiscal: optionalString.pipe(z.string().max(50, "Máximo de 50 caracteres").nullable().optional()),
  ValorRetencao: optionalDecimal,
  IdSubconta: optionalNumber,
  Descricao: optionalString.pipe(z.string().max(10, "Máximo de 10 caracteres").nullable().optional()),

  //Extra
  IdCentroCusto: optionalString,
  ValorTotalCalculado: optionalDecimal,
  SubTotal: optionalDecimal,
});

export type MedicaoTerceirizacaoForm = z.infer<typeof MedicaoTerceirizacaoSchema>;